<template>
	<v-tooltip top>
		<template #activator="{ on }">
			<v-btn v-on="on" @click.stop="copy(link)" icon>
				<v-icon>mdi-link</v-icon>
			</v-btn>
		</template>
		<span>Copy link</span>
	</v-tooltip>
</template>

<script>
export default {
	name: 'CopyLinkButton',
	props: {
		link: {
			type: String,
			required: true
		},
	},
	methods: {
		copy(link) {
			if (!link || !link.startsWith('http')) {
				link = window.location.origin + link
			}
			this.copyToClipboard(link)
			this.$root.success('Link copied to clipboard')
		}
	}
};
</script>

<style>

</style>